import * as React from 'react';
import './style.css';

interface DonateButtonProps {
  className: string;
}

export const DonateButton: React.SFC<DonateButtonProps> = props => {
  return (
    <form
      action="https://www.paypal.com/cgi-bin/webscr"
      method="post"
      target="_top"
      {...props}
    >
      <input type="hidden" name="cmd" value="_s-xclick" />

      <input type="hidden" name="hosted_button_id" value="B93T36PP5PPY6" />

      <input
        type="image"
        src="https://www.paypalobjects.com/en_GB/i/btn/btn_donate_LG.gif"
        data-border="0"
        name="submit"
        title="PayPal - The safer, easier way to pay online!"
        alt="Donate with PayPal button"
      />

      <img
        alt=""
        data-border="0"
        src="https://www.paypal.com/en_GB/i/scr/pixel.gif"
        width="1"
        height="1"
      />
    </form>
  );
};

export default DonateButton;



// WEBPACK FOOTER //
// ./src/app/components/Common/DonateButton/index.tsx